<template>
    <div>
        <div class="profile-type">
            <span v-if="profile.billing_type == 'pf'">{{ $t('pf') }}</span>
            <span v-if="profile.billing_type == 'pj'">{{ $t('pj') }}</span>
        </div>
        <div class="profile-name">
            {{profile.name}}
        </div>
        <div class="row address">
            <div class="col">
                <div class="fiscal-or-address">
                    {{profile.fiscal_or_address}}, {{profile.country_name}}
                </div>
                <div class="text-warning" v-if="!isValidatedProfile(profile)">
                    {{ $t('profiles_unverified_data') }}
                </div>
            </div>
        </div>

        <div class="instant-credit" v-if="profile.has_instant_credit || profile.has_instant_credit_tpf">
            <br/>
            <template v-if="profile.has_instant_credit && profile.instant_limit_amount > 0">
                <div class="amount">
                    {{ $t('payment_method_credit_erv') }}: {{profile.instant_limit_amount.toFixed(2)}} {{ $tc('currency', profile.instant_limit_amount) }}
                </div>
            </template>
            <template v-if="profile.has_instant_credit_tpf && profile.instant_limit_tpf_amount > 0">
                <div class="amount">
                    {{ $t('payment_method_credit_tpf') }}: {{profile.instant_limit_tpf_amount.toFixed(2)}} {{ $tc('currency', profile.instant_limit_tpf_amount) }}
                </div>
            </template>
        </div>

        <div class="instant-debit" v-if="profile.has_instant_debit || profile.has_instant_debit_tpf">
            <br/>
            <template v-if="profile.has_instant_debit && profile.instant_debit_limit_amount > 0">
                <div class="amount">
                    {{ $t('payment_method_debit_erv') }}: {{profile.instant_debit_limit_amount.toFixed(2)}} {{ $tc('currency', profile.instant_debit_limit_amount) }}
                </div>
            </template>
            <template v-if="profile.has_instant_debit_tpf && profile.instant_debit_limit_tpf_amount > 0">
                <div class="amount">
                    {{ $t('payment_method_debit_tpf') }}: {{profile.instant_debit_limit_tpf_amount.toFixed(2)}} {{ $tc('currency', profile.instant_debit_limit_tpf_amount) }}
                </div>
            </template>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        profile: {
            type: Object,
            default: () => null        
        }
    }
}

</script>

<style lang="scss" scoped>

.profile-name {
    font-size: 22px;
    font-weight: bold;
}

</style>